import './App.css';
import Banner from './Banner';
import React, { useState, useEffect, useRef} from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import Grid from './Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
 
const Paragraph = ({ id }) => {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash === `#${id}`) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [id, location.hash]);

  return (
    <div id={id} className="paragraph">
      {/* Your paragraph content here */}
    </div>
  );
};



const headerSize = {
  fontSize: '32px'
};

const parSize = {
  fontSize: '20px'
};

const numColor = {
  color: '#0583a0'
};

const txtColor = {
  color: '#ffb703'
};
const AboutSection = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);


  const updateScreenDimensions = () => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateScreenDimensions);

    return () => {
      window.removeEventListener('resize', updateScreenDimensions);
    };
  }, []);

  return (
    <div id="about">
      <div className='about-txt'  style={{width:screenWidth*0.7, position:'relative',
  textAlign:'left'}}>

        <h2 className="headerz" style={headerSize}><span style={numColor}>01.</span> About Me</h2>
        <p>
          <div className="bodyz" style={parSize}>
            <p>Currently a graduating university student with a keen interest in software enginnering and machine learning, I am highly
              motivated by challenging tasks that enable me to learn and develop new skills. While I do not claim expertise in
              every area, I am a quick and determined learner who is always eager to expand my knowledge. I am self-motivated
              and enjoy writing high-performance code using the latest technologies. Having gained experience in both software
              development and data analytics, I am confident in my ability to contribute to teams that prioritize collaboration
              and problem-solving.

            </p>
          </div>
        </p>
      </div >
    </div >
  );
};

const ExpSection = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);


  const updateScreenDimensions = () => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateScreenDimensions);

    return () => {
      window.removeEventListener('resize', updateScreenDimensions);
    };
  }, []);
  return (
    <div id="exp" style={{width:screenWidth*0.7, position:'relative',
    textAlign:'left'}}>
      <div className='skills-txt' style={{width:screenWidth*0.7, position:'relative',
  textAlign:'left'}}>

        <h2 className="headerz" style={headerSize}><span style={numColor}>02.</span> Skills</h2>
        <p>
          <div className="bodyz" style={parSize}>
            <ul>
              <li style={numColor}> <span style={txtColor}>Programming languages<a style={numColor}>:</a> Python, Java, C, JavaScript, SQL</span> </li>
              <li style={numColor}> <span style={txtColor}>Web development<a style={numColor}>:</a> HTML, CSS, React, Node.js</span> </li>
              <li style={numColor}> <span style={txtColor}>Distributed Systems<a style={numColor}>:</a> Apache Spark, Dask</span> </li>
              <li style={numColor}> <span style={txtColor}>GPU Acceleration<a style={numColor}>:</a> CUDA, PyTorch-GPU, TensorFlow-GPU, RAPIDS AI</span> </li>
              <li style={numColor}> <span style={txtColor}>Cloud Computing<a style={numColor}>:</a> GCP, Azure, Databricks</span> </li>
              <li style={numColor}> <span style={txtColor}>Experience in integrating and connecting different frameworks and languages</span></li>
            </ul>
          </div>
        </p>
      </div>
    </div >
  );
};

const ProjectSection = () => {
  const data = [
 


    {
      id: -3,
      title: 'Popular ML algorithms for 4 class-ification',
      info: 'Predicting mobile phone price range based on various features.',
      url: './files/sb_mobile_nb.html',
      readme: './files/ml1.pdf'
    },


    {
      id: -2,
      title: ['Database Manager  ', <FontAwesomeIcon icon={faGithub} size="sm" />],
      info: 'A Java GUI app in which user can create/modify a database and show different graphs of the selected data.',
      url: 'https://github.com/ChristosG/dbgraph',
      readme: 'https://github.com/ChristosG/dbgraph/blob/main/README.md'
    },


    {
      id: -1,
      title: 'Transformers GPT-2 model fine-tuned for classification',
      info: 'Takes random restaurant reviews and predicts the type of restaurant.',
      url: './files/sb_erwt2_gpt2.html',
      readme: './files/erwt2_all.html'
    },
    {
      id: 0,
      title: 'Computer vision techniques',
      info: 'Train and test of models for digit recognition ',
      url: './files/convo.html',
      readme: ''
    },

    {
      id: 1,
      title: ['High-performance Search Engine  ', <FontAwesomeIcon icon={faGithub} size="sm" />],
      info: 'A Java GUI app that utilizes Lucene for multithreaded search functionality. Supports word embeddings for similar meaning search, and maintains a search history.',
      url: 'https://github.com/ChristosG/infoint',
      readme: 'https://github.com/ChristosG/infoint/blob/main/README.md'
    },

    {
      id: 2,
      title: 'Transformers BERT model fine-tuned for classification',
      info: 'Takes random restaurant reviews and predicts the type of restaurant.',
      url: './files/erwt2_all.html',
      readme: './files/sb_bert_finder.html'
    },
    {
      id: 3,
      title: 'Distributed ML with rapids ai, dask and pyspark',
      info: 'KNN, SVM, Neural Network for binary classification on flight delays',
      url: './files/sb_rapidz.html',
      readme: './files/KNN_bayes.html'
    },
    {
      id: 4,
      title: 'Clustering evaluations',
      info: 'Predicting mobile phone price range based on various features, by using popular clustering algorithms.',
      url: './files/mlask2.html',
      readme: './files/ml26.pdf'
    },
    {
      id: 5,
      title: 'Exploratory data analysis on Yelp',
      info: 'Finding intresting correlations on restaurant reviews, based on various metrics.',
      url: './files/1_3.html',
      readme: './files/1g1000.jpg'
    },

    {
      id: 6,
      title: 'Recommendation systems',
      info: 'Predicting business ratings of users, using different techniques.',
      url: './files/2_2.html',
      readme: './files/1g1000.jpg'
    },


    {
      id: 7,
      title: 'Numpy vs Cupy on image processing',
      info: 'Difference on array calculations made between CPU-RAM and GPU.',
      url: './files/numpy_vs_cupy.html',
      readme: './files/1g1000.jpg'
    },

    {
      id: 8,
      title: ['LaTeX Editor  ', <FontAwesomeIcon icon={faGithub} size="sm" />],
      info: 'A Java GUI app for creating or editing LaTeX files supporting a wide range of LaTeX commands and providing  features like undo/redo, auto-saving and more.',
      url: 'https://github.com/ChristosG/latex-editor',
      readme: 'https://github.com/ChristosG/latex-editor/blob/main/README.md'
    },




    {
      id: 9,
      title: 'Classification using popular ML aglorithms',
      info: 'Classifying random reviews into categories using different ML algorithms and evaluating them.',
      url: './files/3_2.html',
      readme: './files/1g1000.jpg'
    },
    {
      id: 10,
      title: 'SVM on GPU vs CPU',
      info: 'SVM and Neural Network for binary classification on flight delays',
      url: './files/sb_NN_SVM.html',
      readme: './files/KNN_bayes.html'
    },
    {
      id: 11,
      title: 'Big Data algorithms part_1',
      info: 'Finding nearest neighbours in a document collection.',
      url: './files/big_data_algos.html',
      readme: './files/bd1.pdf'
    },

    {
      id: 12,
      title: 'Big Data algorithms part_2',
      info: 'Another approach for finding nearest neighbours in a document collection.',
      url: './files/bd2.ipynb',
      readme: './files/sb_bd2.pdf'
    },




    {
      id: 13,
      title: 'Finding meaningful key words',
      info: 'Finding positive and negative phrases, which are present on random reviews, that are used to describe restaurants.',
      url: './files/3_4.html',
      readme: './files/3_4b.html'
    },
    {
      id: 14,
      title: ['Text-to-Speech Converter  ', <FontAwesomeIcon icon={faGithub} size="sm" />],
      info: 'A Java GUI app that utilizes the FreeTTS API. Users can customize voice, pitch, volume, and input text or open text files for conversion.',
      url: 'https://github.com/ChristosG/text2speech',
      readme: 'https://github.com/ChristosG/text2speech/blob/main/README.md'
    },
    {
      id: 15,
      title: 'Predictions using Value Propagation on a social network.',
      info: 'Rating prediction of users, based on what their friends rated.',
      url: './files/3_3.html',
      readme: './files/1g1000.jpg'
    },
    {
      id: 16,
      title: 'React-Native Commercial App',
      info: 'An app for a promotion event, made with react-native with dynamic alignment for every screen.',
      url: './app',
      readme: 'https://github.com/ChristosG/react-native-minigame/tree/main'
    },


    {
      id: 17,
      title: 'Restaurant type clustering',
      info: 'Category clustering on random reviews of 3 types of restaurants.',
      url: './files/2_3.html',
      readme: './files/1g1000.jpg'
    },


    {
      id: 18,
      title: 'Add scroll bar on ipynb.html outputs',
      info: 'Adds a scrollbar on output shells of a jupyter notebook which is saved as html.',
      url: './files/addscrollbar.py',
      readme: './files/1g1000.jpg'
    },

    {
      id: 19,
      title: 'PDF Editor',
      info: 'All pdf editors have subscription, or applying a watermark, so why not make mine? Changes internal title.',
      url: './files/change_pdf_title.py',
      readme: './files/1g1000.jpg'
    },
    {
      id: 20,
      title: 'Real Time Stock predictions',
      info: 'A financial DL-network to analyze positive data from twitter. LSTM and a NN to predict the next price of a stock',
      url: './files/twe.html',
      readme: './files/lstm_stock.html'
    },
    {
      id: 21,
      title: 'Real Time Stock predictions v2',
      info: 'XG boost vs RF to predict the next price of stock. XG fighting with RF to produce the best prediction.',
      url: './files/xg_vs_rf.html',
      readme: './files/xgb.html'
    },

  
  ];

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);


  const updateScreenDimensions = () => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateScreenDimensions);

    return () => {
      window.removeEventListener('resize', updateScreenDimensions);
    };
  }, []);
  
  return (
    <div id="projects" style={{justifyContent:'center', width:screenWidth*0.7, position:'relative',
    textAlign:'center',   marginLeft:'10%'
  }}>
      <div className='project-txt' style={{justifyContent:'center', width:screenWidth*0.7, position:'relative',
  textAlign:'left',  
}}>

        <div className='aasd' style={{marginLeft:'-10%'}}><h2 className="headerz" style={headerSize}><span style={numColor}>03.</span> My work</h2></div>
        <p>
          <div style={parSize}>

          </div>
        </p>
      </div>
      <div className='app-grid' styles={{justifyContent:'center',
  display:'flex',
  marginLeft:'10%'
 }
}>
        <Grid data={data} />
      </div>
    </div>
  );
};

const ContactSection = () => {
  return (
    <div id="contact">
      <div className='contact-txt'>

        <h2 className="headerz" style={headerSize}><span style={numColor}>04.</span> Get In Touch</h2>
        <p>
          <div className="bodyz" style={parSize}>
            <p>Email: cgrigoriadis@outlook.com</p>
            <p>Phone: +30 6980923962</p>
          </div>
        </p>
      </div>
    </div>
  );
};


const email = '       cgrigoriadis@outlook.com';

const handleClick = () => {
  window.location.href = `mailto:${email}`;
};


function handleGithubClick(event) {

  event.stopPropagation();

  window.open("https://github.com/ChristosG?tab=repositories");
}


function App() {

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    // Attach the hash change event listener
    window.addEventListener('hashchange', handleHashChange);

    // Initial check in case the URL already has a hash
    handleHashChange();

    // Clean up the event listener
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  

  return (

    <Router>
    <div className='whole'>

    <div className="App">

 

      <Banner></Banner>
      <div className="App-header">

      <Routes>

<Route path="/about" component={<AboutSection />} /> 
<Route path="/experience" component={<ExpSection/>} />
<Route path="/#projects" component={<ProjectSection/>} />
<Route path="/~cse42680/contact" component={<ContactSection/>} />
<Route path="/" component={<AboutSection/>} />
</Routes>

        <AboutSection sw={'20%'}></AboutSection>

        <ExpSection></ExpSection>
        <div id="projects" className="projects"></div>
        <ProjectSection>
        

        </ProjectSection>
        <div id="contact" className="contact"></div>


        <ContactSection></ContactSection>

      </div>

      <div className="container">

        <div className="vertical-text" >
          <span className="icon-wrapper" onClick={handleGithubClick}>
            <FontAwesomeIcon icon={faGithub} size="sm" />
          </span>
          <span className="email-text" onClick={handleClick}>
            {email}
          </span>
        </div>

      </div>

    </div ></div>
    </Router>
  );
}

export default App;


